import Button from 'components/UI/Button';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from 'components/UI/Dialog';

function BaseAlert({
    body,
    onClose,
    onAccept,
    showDialog,
    acceptProps,
    cancelProps,
    showAcceptButton,
    fullSize,
    showCancelButton,
    mediumSizeModal,
})
{
    const acceptClass = {
        bgColor: `tw-bg-${acceptProps.bgColor}-500`,
    };

    const cancelClass = {
        bgColor: `tw-bg-${cancelProps.bgColor}-500`,
    };

    return (
        <Dialog
            model={{
                value: showDialog,
                setter: onClose,
            }}
            fullSize={fullSize}
            mediumSizeModal={mediumSizeModal}
        >
            <div className="tw-py-4">
                <div className="tw-justify-between tw-text-base tw-mb-4 tw-text-left">
                    <div>{body}</div>
                </div>

                <div className="tw-text-right">
                    {cancelProps.show && (
                        <Button
                            customBg={cancelClass.bgColor}
                            onClick={onClose}
                        >{cancelProps.text}</Button>
                    )}
                </div>
                <div className="tw-flex">
                    {showCancelButton && (
                        <div className="flex-1 tw-text-left">
                            {acceptProps.show && (
                                <Button
                                    customBg="tw-bg-red-500"
                                    onClick={onClose}
                                >{cancelProps.text}</Button>
                            )}
                        </div>
                    )}
                    {showAcceptButton && (
                        <div className="flex-1 tw-w-full tw-text-right  ">
                            {acceptProps.show && (
                                <Button
                                    customBg={acceptClass.bgColor}
                                    onClick={onAccept}
                                >{acceptProps.text}</Button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
}

BaseAlert.defaultProps = {
    showDialog: false,
    acceptProps: {
        bgColor: 'green',
        text: 'Accept',
        show: true,
    },
    cancelProps: {
        bgColor: 'red',
        text: 'Cancel',
        show: false,
    },
    showAcceptButton: true,
    showCancelButton: false,
    fullSize: false,
};

BaseAlert.propTypes = {
    showAcceptButton: PropTypes.bool,
    showCancelButton: PropTypes.bool,
    showDialog: PropTypes.bool,
    body: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
    acceptProps: PropTypes.shape({
        bgColor: PropTypes.string,
        text: PropTypes.string,
        show: PropTypes.bool,
    }),
    cancelProps: PropTypes.shape({
        bgColor: PropTypes.string,
        text: PropTypes.string,
        show: PropTypes.bool,
    }),
    fullSize: PropTypes.bool,
    mediumSizeModal: PropTypes.bool,
};

export default BaseAlert;
